<div class="ta">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Iskolaváltás – átadó csomag</ion-card-title>
      <ion-card-subtitle>
        „Iskolaváltás esetén az iskola az új iskolának a tanulmányi rendszeren keresztül adja át a gyermek, tanuló tantárgyankénti
        előrehaladást igazoló adatait és tanítási év közbeni iskolaváltás esetén az évközi érdemjegyeit is.” (Nkt. 41. § (8a))
        A csomag géppel olvasható (JSON) és nyomtatható (PDF) formában készül; a Sulinform nem küldi el, a fájlt a saját csatornátokon
        (hivatali kapu, e-mail) adjátok át.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div *ngIf="!tanulo">
        <ion-searchbar [(ngModel)]="kereses" (ionInput)="keres()" [debounce]="300" placeholder="Tanuló neve vagy oktatási azonosítója (a volt tanulók is)"></ion-searchbar>
        <ion-list *ngIf="talalatok.length">
          <ion-item button *ngFor="let t of talalatok" (click)="valaszt(t)">
            <ion-label>
              <h3>{{ t.nev }} <small>{{ t.oktazon }}</small></h3>
              <p>{{ t.osztaly || '–' }}{{ t.szul_datum ? ' · szül.: ' + (t.szul_datum | date:'yyyy.MM.dd.') : '' }}</p>
            </ion-label>
            <ion-badge slot="end" [color]="t.aktiv ? 'success' : 'medium'">{{ t.aktiv ? 'aktív' : 'volt tanuló' }}</ion-badge>
          </ion-item>
        </ion-list>
      </div>
      <div *ngIf="tanulo" class="ta-sor">
        <b>{{ tanulo.nev }}</b> <span class="halvany">{{ tanulo.oktazon }} · {{ tanulo.osztaly || '–' }}</span>
        <ion-button fill="clear" size="small" (click)="tanuloTorol()">Másik tanuló</ion-button>
      </div>
      <ion-note color="danger" *ngIf="hiba">{{ hiba }}</ion-note>
    </ion-card-content>
  </ion-card>

  <!-- Iskolaváltással kilépett tanulók, akiknek a kilépés körül nem készült átadó csomag (az elmúlt egy évből). -->
  <ion-card *ngIf="!tanulo && hianyzok.length">
    <ion-card-header>
      <ion-card-title>Elmaradt átadó csomagok ({{ hianyzok.length }})</ion-card-title>
      <ion-card-subtitle>
        Iskolaváltással kilépett tanulók (a megszűnés oka „Másik iskola átvette”, vagy meg van adva az új intézmény), akiknek a
        kilépés előtti 30. naptól nem készült csomag. A tanulóra kattintva elkészíthető.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <ion-list>
        <ion-item button *ngFor="let h of hianyzok" (click)="valasztOktazon(h.oktazon)">
          <ion-label>
            <h3>{{ h.nev }} <small>{{ h.oktazon }}</small></h3>
            <p>{{ h.osztaly || '–' }} · kilépett: {{ h.vege }}{{ h.atvevo_intezmeny ? ' · új iskola: ' + h.atvevo_intezmeny : '' }}</p>
          </ion-label>
          <ion-badge slot="end" color="warning">nincs csomag</ion-badge>
        </ion-item>
      </ion-list>
    </ion-card-content>
  </ion-card>

  <ion-card *ngIf="tanulo">
    <ion-card-header>
      <ion-card-title>Átadó csomag készítése</ion-card-title>
      <ion-card-subtitle>
        Tartalma: azonosító törzsadatok, osztály és évfolyam, a tanév évközi jegyei (stornó és „nem írta” nélkül), a félévi és év végi
        értékelések tantárgyanként, a mulasztás-összesítő (igazolt, igazolatlan, késés) és a záradékok. Különleges adat (SNI, BTMN),
        TAJ és adóazonosító nem kerül bele. Minden letöltés naplózódik.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="ta-sor">
        <ion-input label="Tanév (kezdő év, üresen: a mostani)" labelPlacement="stacked" fill="outline" [(ngModel)]="tanev" maxlength="4" placeholder="pl. 2026"></ion-input>
        <ion-button (click)="jsonLetolt()" [disabled]="fut"><ion-icon slot="start" name="code-download-outline"></ion-icon>JSON letöltése</ion-button>
        <ion-button fill="outline" (click)="pdf()" [disabled]="fut"><ion-icon slot="start" name="document-outline"></ion-icon>PDF</ion-button>
      </div>
    </ion-card-content>
  </ion-card>

  <ion-card *ngIf="tanulo">
    <ion-card-header>
      <ion-card-title>Csomag átvétele egy másik iskolától</ion-card-title>
      <ion-card-subtitle>
        Egy másik Sulinform által készített átadó csomag (JSON) feltöltése ehhez a tanulóhoz. A jegyek és a mulasztások NEM kerülnek
        át a saját naplónkba – „átvett előzmény”-ként, változatlanul tároljuk, és itt olvashatók. A módosított csomagot a rendszer elutasítja.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="ta-sor">
        <input type="file" accept=".json,application/json" (change)="fajlValasztas($event)">
        <span class="halvany" *ngIf="feltoltottNev">{{ feltoltottNev }}</span>
      </div>
      <div *ngIf="feltoltott" class="elonezet">
        <div><b>{{ nev(feltoltott.tanulo?.viselt_nev) }}</b> ({{ feltoltott.tanulo?.oktatasi_azonosito }})</div>
        <div class="halvany">Küldő: {{ feltoltott.kiallito?.nev }} (OM {{ feltoltott.kiallito?.om }}) · tanév: {{ feltoltott.tanev?.nev }} ·
          {{ feltoltott.evkozi_jegyek?.length || 0 }} évközi jegy · készült: {{ feltoltott.keszult | date:'yyyy.MM.dd. HH:mm' }}</div>
        <div class="ta-sor">
          <ion-input label="Megjegyzés (nem kötelező)" labelPlacement="stacked" fill="outline" [(ngModel)]="atvetelMegj" maxlength="500"></ion-input>
          <ion-button (click)="atvesz()" [disabled]="fut || !!atvetelHiba"><ion-icon slot="start" name="download-outline"></ion-icon>Átvétel</ion-button>
        </div>
      </div>
      <ion-note color="danger" *ngIf="atvetelHiba">{{ atvetelHiba }}</ion-note>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Átvett előzmények{{ tanulo ? ' – ' + tanulo.nev : ' (az intézmény összes)' }}</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <p class="halvany" *ngIf="!elozmenyek.length">Nincs átvett csomag.</p>
      <div class="gorgo" *ngIf="elozmenyek.length">
        <table class="ta-tabla">
          <tr><th>Tanuló</th><th>Küldő iskola</th><th>Tanév</th><th>Jegyek</th><th>Átvéve</th><th></th></tr>
          <ng-container *ngFor="let e of elozmenyek">
            <tr [class.visszavont]="e.visszavonva">
              <td><b>{{ e.nev || e.oktazon }}</b><div class="kicsi">{{ e.oktazon }}</div></td>
              <td>{{ e.forras_nev || '–' }}<div class="kicsi">OM {{ e.forras_om || '–' }} · készült: {{ e.forras_keszult || '–' }}</div></td>
              <td>{{ e.tanev_nev }}</td>
              <td>{{ e.jegy_db }}</td>
              <td>{{ e.atveve }}<div class="kicsi">{{ e.atvette }}{{ e.megjegyzes ? ' · ' + e.megjegyzes : '' }}</div>
                <div class="kicsi figy" *ngIf="e.visszavonva">Visszavonva: {{ e.visszavonva }} ({{ e.visszavonta }}) – {{ e.visszavonas_oka }}</div></td>
              <td class="nw">
                <ion-button size="small" fill="clear" (click)="megnyit(e)">{{ nyitottId === e.id ? 'Bezár' : 'Megnyit' }}</ion-button>
                <ion-button size="small" fill="clear" (click)="elozmenyPdf(e)">PDF</ion-button>
                <ion-button size="small" fill="clear" color="danger" *ngIf="!e.visszavonva" (click)="visszavon(e)">Visszavon</ion-button>
              </td>
            </tr>
            <tr *ngIf="nyitottId === e.id && nyitott" class="reszlet">
              <td colspan="6">
                <div class="kicsi">Átvett előzmény – a küldő iskola adatai, változatlanul (nem a mi bejegyzéseink).</div>
                <div><b>Osztály:</b> {{ nyitott.aktualis?.osztaly || '–' }} · <b>évfolyam:</b> {{ nyitott.aktualis?.evfolyam || '–' }} ·
                  <b>mulasztás:</b> {{ nyitott.mulasztas?.orak?.osszes || 0 }} óra (igazolt {{ nyitott.mulasztas?.orak?.igazolt || 0 }},
                  igazolatlan {{ nyitott.mulasztas?.orak?.igazolatlan || 0 }}), késés {{ nyitott.mulasztas?.keses?.darab || 0 }} alkalom</div>
                <table class="ta-tabla belso" *ngIf="nyitott.evkozi_jegyek?.length">
                  <tr *ngFor="let t of jegyekTantargyankent(nyitott)">
                    <td class="tt">{{ t.tantargy }}</td>
                    <td><span class="jegy" *ngFor="let j of t.jegyek" [title]="(j.mod || '') + (j.tema ? ' – ' + j.tema : '') + ' · ' + j.datum">{{ j.ertekeles }}</span></td>
                  </tr>
                </table>
                <div *ngIf="nyitott.tantargyi_eredmenyek?.length" class="kicsi">
                  Félévi / év végi értékelések: {{ nyitott.tantargyi_eredmenyek.length }} tétel (a PDF-ben tételesen).
                </div>
                <div *ngIf="nyitott.zaradekok?.length">
                  <b>Záradékok:</b>
                  <div class="kicsi" *ngFor="let z of nyitott.zaradekok">{{ z.datum | date:'yyyy.MM.dd.' }} – {{ z.szoveg }}</div>
                </div>
              </td>
            </tr>
          </ng-container>
        </table>
      </div>
    </ion-card-content>
  </ion-card>
</div>
